<template>
  <div class="wrapper-dashboard">
    <div class="ui container">
      <h2 class="title">Análise por grupo</h2>
      <t-table-gender />
      <t-table-classification />
      <t-table-age />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    TTableGender: () => import('@/components/tables/dashboard/table-gender.vue'),
    TTableClassification: () => import('@/components/tables/dashboard/table-classification.vue'),
    TTableAge: () => import('@/components/tables/dashboard/table-age.vue')
  },
}
</script>

<style lang="scss">
@import "@/assets/css/colors.scss";

.wrapper-dashboard {
  .title-group {
    font-size: 20px;
    line-height: 29px;
    font-weight: 700;
    color: $gray-700;
    margin-top: 20px;
  }

  .title {
    font-size: 25px;
    line-height: 36px;
    font-weight: 700;
    color: $gray-700;
  }

  table.tui.tuim.ui.table {
    margin-bottom: 30px;
  }
}
</style>
